import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'
import { Select } from '@resurs/midas-react'
import { Countries } from '@merchant-portal/mp-models'
import { getText } from '../../../internal/TextLabels'
import { sendChatEvent } from '../../../util/ga-helpers'
import { isSelectedChatSupportOpen } from '../../../models/contactInformation'

export const ChatRequestForm = ({
  label,
  dropDownText,
  choices,
  onChange,
  defaultValue,
  country,
  setIsClosed,
}) => {
  const values = () => {
    const _values = []
    choices.map(choice => {
      const { value, valueLabel, type } = choice
      _values.push({ key: value, value, valueLabel, type })
      return choice
    })
    return _values
  }

  const sendChatRequestEvent = value => {
    const lbl = values().filter(choice => choice.value === value)
    if (lbl.length) {
      sendChatEvent(lbl[0].valueLabel)
    }
  }

  const handleSelectChange = value => {
    const selectValue = values().find(val => val.value === value)
    const isOpen = isSelectedChatSupportOpen(country, selectValue.type)

    if (!isOpen) {
      setIsClosed(true)
    } else {
      setIsClosed(false)
      sendChatRequestEvent(value)
    }
    onChange(value)
  }

  const props = {
    id: 'requestType',
    label,
    optionsLabel: defaultValue === dropDownText ? dropDownText : null,
    value: defaultValue,
    defaultValue,
    values: values(),
    onChange: handleSelectChange,
  }

  const labelStyle = {
    display: 'block',
    fontWeight: 500,
    textTransform: 'uppercase',
  }

  const tooltipStyle = {
    maxWidth: '250px',
  }

  useEffect(() => {
    if (Number(props.defaultValue)) {
      handleSelectChange(props.defaultValue)
    }
  }, [])

  return (
    <div>
      <div data-tip data-for="chatTip">
        <Select {...props} />
      </div>
      <ReactTooltip place="left" effect="solid" id="chatTip">
        <div style={tooltipStyle}>
          <ul style={{ listStyleType: 'none' }}>
            <li>
              <label style={labelStyle}>
                {getText('chat.request.errandType.storeLabel')}
              </label>
              <span>{getText('chat.request.errandType.storeText')}</span>
            </li>
            {country !== Countries.FI ? (
              <li>
                <label style={labelStyle}>
                  {getText('chat.request.errandType.terminalLabel')}
                </label>
                <span>{getText('chat.request.errandType.terminalText')}</span>
              </li>
            ) : null}
            <li>
              <label style={labelStyle}>
                {getText('chat.request.errandType.materialLabel')}
              </label>
              <span>{getText('chat.request.errandType.materialText')}</span>
            </li>
            <li>
              <label style={labelStyle}>
                {getText('chat.request.errandType.paymentsLabel')}
              </label>
              <span>{getText('chat.request.errandType.paymentsText')}</span>
            </li>
            <li>
              <label style={labelStyle}>
                {getText('chat.request.errandType.creditLabel')}
              </label>
              <span>{getText('chat.request.errandType.creditText')}</span>
            </li>
          </ul>
        </div>
      </ReactTooltip>
    </div>
  )
}

ChatRequestForm.propTypes = {
  label: PropTypes.string.isRequired,
  dropDownText: PropTypes.string.isRequired,
  choices: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  defaultValue: PropTypes.string.isRequired,
  country: PropTypes.oneOf(Object.values(Countries)).isRequired,
  setIsClosed: PropTypes.func.isRequired,
}
